// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Document: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 59"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M44.6 17.1L29.5.1H3.6C1.8.1.4 1.5.4 3.3v52.4c0 1.8 1.4 3.2 3.2 3.2h37.9c1.8 0 3.2-1.4 3.2-3.2V17.4c-.1-.1-.1-.3-.1-.3zM3.2 3.3c0-.2.2-.4.4-.4h23.9v12.6c0 1.7 1.4 3.6 3.2 3.6H42v36.6c0 .2-.2.4-.4.4h-38c-.2 0-.4-.2-.4-.4V3.3zm27.5 13.1c-.1-.1-.4-.5-.4-.9V5.1l10 11.3h-9.6z"/><path d="M11 26.4h23.2c.6 0 1-.4 1-1v-.8c0-.6-.4-1-1-1H11c-.6 0-1 .4-1 1v.8c0 .5.4 1 1 1zm0 7.2h23.2c.6 0 1-.4 1-1v-.8c0-.6-.4-1-1-1H11c-.6 0-1 .4-1 1v.8c0 .6.4 1 1 1zm0-14.4h10.6c.6 0 1-.4 1-1v-.8c0-.6-.5-1-1-1H11c-.6 0-1 .4-1 1v.8c0 .6.4 1 1 1zm0 21.6h23.2c.6 0 1-.4 1-1V39c0-.6-.4-1-1-1H11c-.6 0-1 .4-1 1v.8c0 .6.4 1 1 1zm0 7.2h23.2c.6 0 1-.4 1-1v-.8c0-.6-.4-1-1-1H11c-.6 0-1 .4-1 1v.8c0 .6.4 1 1 1z"/></svg>;
};

export default React.memo(Document);
